import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25b42e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-box-overlay" }
const _hoisted_2 = { class: "choice-box" }
const _hoisted_3 = { class: "choice-title" }
const _hoisted_4 = { class: "choice-options" }
const _hoisted_5 = ["onClick"]

import type { ChoiceOption } from '../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChoiceBox',
  props: {
    title: {},
    choices: {}
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const selectChoice = (choice: ChoiceOption) => {
  emit('select', choice);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choices, (choice, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: "choice-button",
            onClick: ($event: any) => (selectChoice(choice))
          }, _toDisplayString(choice.text), 9, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})